import {ContainerAttributes} from './settings-types';
import {SearchPageType} from '../../search/search-config';

type SettingsChangedAction = {
    readonly type: 'SETTINGS_CHANGED';
    readonly containerName: string;
    readonly technicalDetails: boolean;
    readonly manualValidation: boolean;
    fieldSpecificSearch: boolean;
};

export type ContainerLoadAction = {
    type: 'CONTAINER_LOAD_FINISHED';
    containers: ContainerAttributes[];
    defaultContainer: string;
    searchPageType: SearchPageType;
};

export type SettingsAction = SettingsChangedAction | ContainerLoadAction;

export function changeSettings(
    containerName: string,
    technicalDetails: boolean,
    manualValidation: boolean,
    fieldSpecificSearch: boolean,
): SettingsChangedAction {
    return {
        type: 'SETTINGS_CHANGED',
        containerName: containerName,
        technicalDetails: technicalDetails,
        manualValidation: manualValidation,
        fieldSpecificSearch: fieldSpecificSearch,
    };
}
